<!-- eslint-disable @angular-eslint/template/no-autofocus -->
<search
	tuiSearch
	appearance="ghost"
	class="border-b-[1px] border-gray-300 flex-grow-0 flex-shrink-0"
>
	<fieldset tuiTextfieldSize="m">
		<tui-textfield iconStart="@tui.search">
			<input
				[disabled]="disabled()"
				[ngModel]="search$ | async"
				(ngModelChange)="this.search$.next($event)"
				placeholder="Search"
				tuiInput
				tuiAutoFocus
			/>
		</tui-textfield>
	</fieldset>
</search>

<cdk-virtual-scroll-viewport class="flex-1" appendOnly [itemSize]="40">
	<tui-data-list>
		@if (filteredOptions$ | async; as filtered) {
			<!-- we only need to dynamically remove this element since the `cdkVirtualFor` handles it itself -->
			@if (filtered.length) {
				<!-- All controller -->
				<button
					tuiOption
					type="button"
					(click)="onSelectAll(filtered)"
					[disabled]="disabled()"
				>
					<input
						size="s"
						tuiCheckbox
						type="checkbox"
						[checked]="allChecked(filtered)"
					/>
					<span>{{ allLabel() | transloco }}</span>
				</button>
			}

			<button
				*cdkVirtualFor="let item of filtered"
				tuiOption
				type="button"
				[value]="item"
				(click)="onSelect(item)"
				[disabled]="disabled()"
			>
				<input
					size="s"
					tuiCheckbox
					type="checkbox"
					[checked]="value.has(item)"
				/>

				@if (item) {
					<span>{{ item }}</span>
				} @else {
					<span class="text-gray-700">
						{{ 'generic.no-value' | transloco }}
					</span>
				}
			</button>
		}
	</tui-data-list>
</cdk-virtual-scroll-viewport>
